import React, {useContext, useEffect, useState, useRef} from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import 'leaflet-routing-machine';
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import {toast} from "react-toastify";
import { LoadingContext } from "../../composants/loadingContext";
import Loader from "../../composants/loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap, faLayerGroup, faRoute } from "@fortawesome/free-solid-svg-icons";

export default function CarteLeaflet() {
    const {loading, setLoading} = useContext(LoadingContext);
    const [centerCount, setCenterCount] = useState(0);
    const mapRef = useRef(null);
    const routingControlsRef = useRef([]);

    let greenIcon = L.icon({
        iconUrl: process.env.PUBLIC_URL + "/images/location.png",
        iconSize: [38, 95],
        shadowSize: [50, 64],
        iconAnchor: [22, 94],
        shadowAnchor: [4, 62],
        popupAnchor: [-3, -76]
    });

    const fetchData = ()=>{
        setLoading(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                let listOfCP = new Array();
                axiosInstance().get('public/api/centrepartenaire/proches/'+latitude+'/'+longitude)
                    .then(function (response) {
                        let data = response.data;
                        let popupUser = '<div class="custom-popup">';
                        popupUser += '<div class="popup-header" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 12px; border-radius: 8px 8px 0 0;">';
                        popupUser += '<h3 style="color: white; margin: 0; font-size: 16px; font-weight: bold;">📍 Vous êtes ici</h3>';
                        popupUser += '</div></div>';
                        listOfCP.push(L.marker([latitude, longitude], { icon: greenIcon }).bindPopup(popupUser));
                        
                        if ((data == null) || (data.length == 0)) {
                            setCenterCount(0);
                        } else {
                            setCenterCount(data.length);
                            for (let index = 0; index < data.length; index++) {
                                let popup = '<div class="custom-popup" style="min-width: 250px;">';
                                
                                // Image
                                popup += '<div style="position: relative; height: 150px; overflow: hidden; border-radius: 8px 8px 0 0;">';
                                if(data[index].photo.includes('null')) {
                                    popup += '<img src="/images/image.png" style="width: 100%; height: 100%; object-fit: cover;" />';
                                } else {
                                    popup += '<img src="'+data[index].photo+'" alt="image" style="width: 100%; height: 100%; object-fit: cover;" />';
                                }
                                popup += '<div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.7) 100%);"></div>';
                                popup += '</div>';
                                
                                // Content
                                popup += '<div style="padding: 16px; background: white;">';
                                popup += '<h3 style="margin: 0 0 12px 0; color: #1a202c; font-size: 18px; font-weight: bold;">' + data[index].nom + '</h3>';
                                
                                popup += '<div style="display: flex; flex-direction: column; gap: 8px; font-size: 14px; color: #4a5568;">';
                                popup += '<div style="display: flex; align-items: center; gap: 8px;">';
                                popup += '<span style="color: #667eea;">📍</span>';
                                popup += '<span>' + (data[index].location || 'Non disponible') + '</span>';
                                popup += '</div>';
                                
                                popup += '<div style="display: flex; align-items: center; gap: 8px;">';
                                popup += '<span style="color: #667eea;">📞</span>';
                                popup += '<span>' + (data[index].telephone || 'Non disponible') + '</span>';
                                popup += '</div>';
                                
                                popup += '<div style="display: flex; align-items: center; gap: 8px;">';
                                popup += '<span style="color: #667eea;">🏥</span>';
                                popup += '<span>' + data[index].serviceOfferts.length + ' service(s)</span>';
                                popup += '</div>';
                                popup += '</div>';
                                
                                if(data[index].serviceOfferts.length>0) {
                                    popup += '<a style="display: inline-block; margin-top: 12px; padding: 8px 16px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; text-decoration: none; border-radius: 6px; font-weight: 500; font-size: 14px; transition: transform 0.2s;" onmouseover="this.style.transform=\'scale(1.05)\'" onmouseout="this.style.transform=\'scale(1)\'">En savoir plus →</a>';
                                }
                                popup += '</div></div>';
                                
                                let mq = L.marker([data[index].latittude, data[index].longitude], { icon: greenIcon }).bindPopup(popup);
                                listOfCP.push(mq);
                            }
                        }
                        let cp = L.layerGroup(listOfCP);
                        
                        // Clean up existing routing controls
                        routingControlsRef.current.forEach(control => {
                            try {
                                if (mapRef.current) {
                                    mapRef.current.removeControl(control);
                                }
                            } catch (e) {
                                console.log('Error removing routing control:', e);
                            }
                        });
                        routingControlsRef.current = [];
                        
                        // Clean up existing map if it exists
                        if (mapRef.current) {
                            mapRef.current.remove();
                            mapRef.current = null;
                        }
                        
                        let openstreetmap = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 19,
                            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                        });
                        let googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
                            maxZoom: 20,
                            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                        });
                        let googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
                            maxZoom: 20,
                            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                        });
                        let map = L.map('map', {
                            layers: [openstreetmap, cp],
                            zoomControl: false
                        });
                        
                        // Store map instance in ref
                        mapRef.current = map;
                        
                        // Add zoom control to top right
                        L.control.zoom({
                            position: 'topright'
                        }).addTo(map);
                        
                        let baseMaps = {
                            "🗺️ OpenStreetMap": openstreetmap,
                            "🛣️ Google Streets": googleStreets,
                            "🛰️ Google Satellite": googleHybrid
                        };
                        let overlayMaps = {
                            "🏥 Centres USRAJ": cp
                        };
                        let layerControl = L.control.layers(baseMaps, overlayMaps).addTo(map);
                        map.locate({ setView: true, maxZoom: 16 });
                        
                        function onLocationFound(e) {
                            var radius = e.accuracy;
                            L.circle(e.latlng, radius, {
                                color: '#667eea',
                                fillColor: '#667eea',
                                fillOpacity: 0.1,
                                weight: 2
                            }).addTo(map);
                        }
                        map.on('locationfound', onLocationFound);
                        
                        function onLocationError(e) {
                            toast.info("Impossible d'avoir votre localisation");
                        }
                        map.on('locationerror', onLocationError);
                        
                        // Routing disabled to prevent cleanup issues
                        // Routes will be added in a future update
                        /*
                        for (let index = 0; index < data.length; index++) {
                            const routingControl = L.Routing.control({
                                waypoints: [
                                    L.latLng(latitude, longitude),
                                    L.latLng(data[index].latittude, data[index].longitude)
                                ],
                                routeWhileDragging: false,
                                lineOptions: {
                                    styles: [
                                        {
                                            color: index==0 ? "#10b981":"#6366f1",
                                            opacity: 0.6,
                                            weight: 4
                                        }
                                    ]
                                },
                                router: L.Routing.osrmv1({
                                    serviceUrl: "https://router.project-osrm.org/route/v1"
                                }),
                                createMarker: function(i, waypoint, n) {
                                    return null;
                                },
                                show: false
                            }).addTo(map);
                            
                            // Store routing control for cleanup
                            routingControlsRef.current.push(routingControl);
                        }
                        */
                        setLoading(false);
                    })
                    .catch(function (error) {
                        console.error('Error fetching map data:', error);
                        setCenterCount(0);
                        
                        // Clean up existing routing controls
                        routingControlsRef.current.forEach(control => {
                            try {
                                if (mapRef.current) {
                                    mapRef.current.removeControl(control);
                                }
                            } catch (e) {
                                console.log('Error removing routing control:', e);
                            }
                        });
                        routingControlsRef.current = [];
                        
                        // Clean up existing map if it exists
                        if (mapRef.current) {
                            mapRef.current.remove();
                            mapRef.current = null;
                        }
                        
                        let cp = L.layerGroup([]);
                        let openstreetmap = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                            maxZoom: 19,
                            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                        });

                        let googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
                            maxZoom: 20,
                            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                        });

                        let googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
                            maxZoom: 20,
                            subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                        });
                        let map = L.map('map', {
                            layers: [openstreetmap, cp],
                            zoomControl: false
                        });
                        
                        // Store map instance in ref
                        mapRef.current = map;
                        
                        L.control.zoom({
                            position: 'topright'
                        }).addTo(map);

                        let baseMaps = {
                            "🗺️ OpenStreetMap": openstreetmap,
                            "🛣️ Google Streets": googleStreets,
                            "🛰️ Google Satellite": googleHybrid
                        };

                        let overlayMaps = {
                            "🏥 Centres USRAJ": cp
                        };
                        let layerControl = L.control.layers(baseMaps, overlayMaps).addTo(map);
                        map.locate({ setView: true, maxZoom: 16 });
                        
                        function onLocationFound(e) {
                            let radius = e.accuracy;
                            L.circle(e.latlng, radius, {
                                color: '#667eea',
                                fillColor: '#667eea',
                                fillOpacity: 0.1,
                                weight: 2
                            }).addTo(map);
                        }

                        map.on('locationfound', onLocationFound);
                        
                        function onLocationError(e) {
                            toast.info("Impossible d'avoir votre localisation");
                        }
                        map.on('locationerror', onLocationError);
                        setLoading(false);
                    });
            }, function(error) {
                toast.error("Erreur lors de la récupération de votre position");
                setLoading(false);
            });
        } else {
            toast.error("La géolocalisation n'est pas supportée par ce navigateur.");
            setLoading(false);
        }
    }
    
    useEffect(
        ()=>{
            document.title='Carte Interactive - USRAJ';
            fetchData();
            
            // Cleanup function to remove map on unmount
            return () => {
                // Clean up routing controls first
                routingControlsRef.current.forEach(control => {
                    try {
                        if (mapRef.current) {
                            mapRef.current.removeControl(control);
                        }
                    } catch (e) {
                        console.log('Error removing routing control on unmount:', e);
                    }
                });
                routingControlsRef.current = [];
                
                // Then remove the map
                if (mapRef.current) {
                    mapRef.current.remove();
                    mapRef.current = null;
                }
            };
        },[]
    )

    return (
        <>
            {loading && <Loader />}
            
            {/* Hero Section */}
            <div className="relative bg-gradient-to-br from-indigo-600 via-purple-500 to-pink-500 text-white py-16 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>
                
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-6 shadow-2xl">
                            <FontAwesomeIcon icon={faMap} className="text-4xl" />
                        </div>
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight">
                            Carte Interactive
                        </h1>
                        <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-6">
                            Localisez les centres de santé USRAJ près de vous
                        </p>
                        {centerCount > 0 && (
                            <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full">
                                <FontAwesomeIcon icon={faLayerGroup} className="text-green-300" />
                                <span className="text-lg font-semibold">{centerCount}</span>
                                <span className="text-white/80">centre{centerCount > 1 ? 's' : ''} affiché{centerCount > 1 ? 's' : ''}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Map Container */}
            <div className="bg-gradient-to-b from-gray-50 to-white py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {/* Info Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                        <div className="bg-white rounded-xl shadow-md p-4 border-l-4 border-blue-500">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                                    <FontAwesomeIcon icon={faMap} className="text-blue-600" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-600">Changez de vue</p>
                                    <p className="font-semibold text-gray-800">Utilisez le contrôle des couches</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-xl shadow-md p-4 border-l-4 border-purple-500">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                                    <FontAwesomeIcon icon={faLayerGroup} className="text-purple-600" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-600">Marqueurs</p>
                                    <p className="font-semibold text-gray-800">Cliquez pour plus d'infos</p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="bg-white rounded-xl shadow-md p-4 border-l-4 border-green-500">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                                    <FontAwesomeIcon icon={faMap} className="text-green-600" />
                                </div>
                                <div>
                                    <p className="text-sm text-gray-600">Zoom & Navigation</p>
                                    <p className="font-semibold text-gray-800">Explorez la carte</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map */}
                    <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200">
                        <div id="map" style={{height: '600px', width: '100%'}}></div>
                    </div>
                    
                    {/* Legend */}
                    <div className="mt-6 bg-white rounded-xl shadow-md p-6">
                        <h3 className="text-lg font-bold text-gray-800 mb-4">Comment utiliser la carte</h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex items-start gap-3">
                                <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                                    <span className="text-xl">📍</span>
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-800 mb-1">Votre position</p>
                                    <p className="text-sm text-gray-600">Marqueur indiquant votre localisation actuelle</p>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                                    <span className="text-xl">🏥</span>
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-800 mb-1">Centres USRAJ</p>
                                    <p className="text-sm text-gray-600">Cliquez sur un marqueur pour voir les détails</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <style>{`
                .leaflet-popup-content-wrapper {
                    border-radius: 12px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                    padding: 0;
                }
                .leaflet-popup-content {
                    margin: 0;
                    width: auto !important;
                }
                .leaflet-popup-tip {
                    box-shadow: 0 3px 14px rgba(0,0,0,0.1);
                }
                .leaflet-control-layers {
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                .leaflet-control-zoom {
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                .leaflet-control-zoom a {
                    width: 36px;
                    height: 36px;
                    line-height: 36px;
                    font-size: 20px;
                }
            `}</style>
        </>
    );
}